import "./Gallery.module.css";
import Header from "@/reusable_sections/Header";
import Gallery from "./sections/Gallery";
import GetInTouch from "./sections/GetInTouch";
import Footer from "@/reusable_sections/Footer";
export default function GalleryPage() {
  return <div>
      <Header />
      <Gallery />
      <GetInTouch />
      <Footer />
    </div>;
}